

const TableTypeText = (props) => {

    return(
        <p className="my-auto">{props.children}</p>
    )
}

export default TableTypeText;